import type { VoiceState } from '../state/types'

interface Props {
	state: VoiceState
	busy: boolean
	onOrbTap: () => void
}

function statusText(state: VoiceState): string {
	switch (state.orb) {
		case 'listening':
			return 'Hallgatom…'
		case 'thinking':
			return 'Gondolkodom…'
		case 'idle':
		case 'muted':
			if (state.done) return 'Rendelés leadva · köszönjük!'
			if (state.statusHint === 'dictate') return 'Mondja el — vagy írja be lent'
			return ''
		default:
			return ''
	}
}

/** Layer 4a — the avatar orb (240px idle / 110px when content is showing),
    animated conic halo behind, status line below. Orb tap = mic toggle. */
export function OrbZone({ state, busy, onOrbTap }: Props) {
	const px = busy ? 110 : 240
	return (
		<div className="am-orb-zone">
			<button
				type="button"
				className="am-orb bloom"
				style={{ width: px, height: px }}
				onClick={onOrbTap}
				aria-label={state.listening ? 'Mikrofon némítása' : 'Mikrofon bekapcsolása'}
			>
				<div className="am-halo">
					<div className="am-halo-fill" />
				</div>
				<div className="am-orb-face">
					<video src="/avatar.mp4" autoPlay loop muted playsInline />
				</div>
			</button>
			<div className="am-status" role="status">{statusText(state)}</div>
		</div>
	)
}
